/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './StyleList.scss';
import fetch from '../../../../../core/fetch';
import { deleteStyle } from '../../../../../actions/district';
import { CLIENT_RENEG_WINDOW } from 'tls';

// fetchPgLayersList what is the path

class StyleList extends React.Component {

  onDelete = (e, v) => {
    e.preventDefault();
    this.props.deleteStyle(this.props.district.prefix, v);
  };

  render() {
    return this.props.styles.length > 0 ? (
      <table className="table">
        <tbody>
          {this.props.styles
            ? _.sortBy(this.props.styles, 'name').map((v, i) => (
              <tr key={i}>
                {/* <td>{v.name}</td>*/}
                <td>{v.nazwa}</td>
                {/* <td>
                  <button className="btn btn-primary" value={i} onClick={(e) => this.props.onModify(e, i)} href="#">Modyfikuj</button>
                </td>*/}
                <td>
                  <button
                    className="btn btn-danger"
                    value={i}
                    onClick={e => this.onDelete(e, v.nazwa)}
                    href="#"
                  >
                      Usuń
                    </button>
                </td>
              </tr>
              ))
            : null}
        </tbody>
      </table>
    ) : (
      <h2>Nie utworzono żadnych styli do tej pory</h2>
    );
  }
}

const mapState = state => ({
  styles: state.district.district.styles,
});

const mapActions = {
  deleteStyle,
};

export default withStyles(s)(
  connect(
    mapState,
    mapActions,
  )(StyleList),
);



// WEBPACK FOOTER //
// src/components/Modals/Settings/Panels/StyleList/StyleList.js